/* eslint-disable no-unused-vars */
import { isPlainObject, isArray, isString } from '@/utils/is'

/**
 * 如果 sourceField 是一个数组， 那就删除该属性，且给reqData 赋值一个新属性 newField, value和以前一样
 * @param {*} reqData
 * @param {*} sourceField
 * @param {*} newField
 */
function fixReqDataFieldEnsureArray(parsedReqData, sourceField, newField) {
  const sourceValue = parsedReqData[sourceField]
  if (isArray(sourceValue)) {
    delete parsedReqData[sourceField]
    parsedReqData[newField] = sourceValue
  }
}

/**
 * 如果 sourceField 是一个字符串， 那就删除该属性，且给reqData 赋值一个新属性 newField, value转换成数字
 * @param {*} parsedReqData
 * @param {*} sourceField
 * @param {*} newField
 */
function fixReqDataFieldEnsureString2Number(parsedReqData, sourceField, newField) {
  const sourceValue = parsedReqData[sourceField]
  if (isString(sourceValue)) {
    delete parsedReqData[sourceField]
    parsedReqData[newField] = Number(sourceValue)
  }
}

export function fixReqPayloadAdjustDataPermission(req) {
  const curReq = req

  try {
    const parsedReqData = curReq.data
    if (!isPlainObject(parsedReqData)) {
      return curReq
    }

    // shopId -> shopIdList
    fixReqDataFieldEnsureArray(parsedReqData, 'shopId', 'shopIdList')
    // shopIds -> shopIdList
    fixReqDataFieldEnsureArray(parsedReqData, 'shopIds', 'shopIdList')
    // countryCode -> countryCodeList
    fixReqDataFieldEnsureArray(parsedReqData, 'countryCode', 'countryCodeList')
    // countryCode -> countryCodeList
    fixReqDataFieldEnsureArray(parsedReqData, 'countryCodes', 'countryCodeList')

    // shopId（string） -> shopId(string)
    fixReqDataFieldEnsureString2Number(parsedReqData, 'shopId', 'shopId')

    // 回填
    curReq.data = parsedReqData

    return curReq
  } catch (err) {
    return curReq
  }
}
